import { IItem, instanceOfIItem } from "./IItem";
import { PatientProfileInformation } from "../../patient/PatientProfileInformation";
import { PatientProfileItem } from "../../patient/PatientProfileItem";

export interface IPatientProfileInformationApplicable extends IItem {
  name: string;
  // isHisInfo: boolean;
  handlePatientProfileInformationApplied(info: PatientProfileInformation): boolean;
  createPatientProfileItem(): PatientProfileItem;
  adjustFontSize(): void;
  isPatientProfileKeyMatched(key: string): boolean;
}

export function instanceOfIPatientProfileInformationApplicable(instance: any): instance is IPatientProfileInformationApplicable {
  return instance
    && (!!instance.name)
    && (!instance.isHisInfo)  // interfaceに記載するとリスト選択・クリック選択にプロパティを用意する必要がある・・
    && (instance.handlePatientProfileInformationApplied !== undefined)
    && instanceOfIItem(instance);
}
